import Box from "@mui/material/Box/Box";
import Typography from "@mui/material/Typography";

type AdProps = {
    style?: React.CSSProperties | undefined
}

export default function Ad({ style }: AdProps) {
    return (
        <Box sx={{ backgroundColor: 'black', color: 'white' }} style={{ display: 'flex', justifyContent: 'flex-end', ...style }}>
            <Typography variant="caption" sx={{ mr: '0.5rem' }}>QR-Menu by ©AT-Corporation</Typography>
        </Box>
    );
}